import { ComposedElement } from "../ComposedElement.mjs";
import { isArrayOf, isNonEmptyString } from "../validation/index.mjs";
export var LinkNode;

(function (LinkNode) {
  LinkNode.TYPE = 'link';

  function isLinkNode(value) {
    return ComposedElement.isComposedElement(value, LinkNode.TYPE);
  }

  LinkNode.isLinkNode = isLinkNode;

  function validateLinkNode(value, validateInlineNode) {
    var isValid = isLinkNode(value) && isNonEmptyString(value.href) && isArrayOf(value.children, node => Boolean(validateInlineNode(node)));
    return isValid ? value : null;
  }

  LinkNode.validateLinkNode = validateLinkNode;
})(LinkNode || (LinkNode = {}));